webpackJsonp([3],{

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1613)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1576),
  /* template */
  __webpack_require__(1649),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpaceAndLocationFilter',
  props: {
    cta: { type: String, default: 'Filters' },
    ctaIcon: { type: String, default: 'filter_list' }
  },
  data: function data() {
    return {
      menu: false,
      selected: []
    };
  },

  methods: {
    emitSelected: function emitSelected(selected) {
      var spaces = [];
      var locations = [];
      selected.forEach(function (item) {
        if (item.startsWith && item.startsWith('space-')) {
          spaces.push(parseInt(item.substring(6)));
        } else {
          locations.push(item);
        }
      });
      this.$emit('input', { spaces: spaces, locations: locations });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['lookups']), {
    spaces: function spaces() {
      if (this.lookups && this.lookups.spaces) {
        var spaces = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.lookups.spaces);
        return spaces.map(function (space) {
          return {
            id: 'space-' + space.id,
            name: space.title,
            children: space.locations
          };
        });
      }
      return [];
    },
    items: function items() {
      return [{
        id: 1,
        name: 'Applications :',
        children: [{ id: 2, name: 'Calendar : app' }, { id: 3, name: 'Chrome : app' }, { id: 4, name: 'Webstorm : app' }]
      }];
    }
  })
});

/***/ }),

/***/ 1569:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1567),
  /* template */
  __webpack_require__(1571),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1571:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-width": 200,
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-badge', {
          attrs: {
            "color": "info",
            "right": "",
            "overlap": ""
          },
          scopedSlots: _vm._u([{
            key: "badge",
            fn: function() {
              return [(_vm.selected && _vm.selected.length > 0) ? _c('span', {
                domProps: {
                  "textContent": _vm._s(_vm.selected.length)
                }
              }) : _vm._e()]
            },
            proxy: true
          }], null, true)
        }, [_vm._v(" "), _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "dark": "",
            "outline": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          staticClass: "mr-2"
        }, [_vm._v(_vm._s(_vm.ctaIcon))]), _vm._v("\n          " + _vm._s(_vm.cta) + "\n        ")], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-system-bar', [_vm._v("\n        Filter results\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.menu = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-treeview', {
    attrs: {
      "dense": "",
      "selectable": "",
      "selection-type": "independent",
      "items": _vm.spaces
    },
    on: {
      "input": _vm.emitSelected
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IntervalSlot',
  props: {
    event: { type: Object, required: true },
    events: { type: Array, required: true },
    color: { type: String },
    intervalHeight: { type: Number, default: 60 }
  },
  methods: {
    dayEventStyle: function dayEventStyle(evt, evts) {
      var offset = 10;
      var top = evt.hour * this.intervalHeight + evt.minute;
      var width = null;
      var left = 5;
      var right = 5;

      if (evt.index > 0) {
        var prev = evts[evt.index - 1];
        if (prev) {
          var hasExactOverlap = evt.exactoverlaps && evt.exactoverlaps.length > 1;
          if (hasExactOverlap) {
            var overlapCount = evt.exactoverlaps.length;
            width = 100 / overlapCount;
            evt.exactoverlaps.forEach(function (item, i) {
              if (!item.left) {
                item.left = i;
              }
            });
            left = evt.left * width;
          } else {
            var hasOverlap = evt.interval.overlaps(prev.interval);
            if (hasOverlap) {
              left = prev.left + offset;
              evt.left = left;
            }
          }
        }
      }
      var style = {
        position: 'absolute',
        top: top + 'px',
        height: evt.duration + 'px',

        right: right + 'px',
        left: left + '%',
        border: 'solid 1px ' + evt.color + ' !important',
        lineHeight: 1,
        overflow: 'hidden'
      };
      if (width) {
        style['width'] = width + '%';
      }
      return style;
    }
  }
});

/***/ }),

/***/ 1575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendar_DayView__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendar_DayView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_calendar_DayView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SharedCalendarDayView',
  components: { DayView: __WEBPACK_IMPORTED_MODULE_0__components_calendar_DayView___default.a },
  props: {
    withTitle: { type: Boolean, default: false },
    calendarId: { required: true },
    touch: { type: Number, default: 0 },
    date: { type: String, required: true },
    title: { type: String, required: true },
    settings: { type: Object, required: false, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      req: {
        resource: 'ag.practitioner.calendars'
      }
    };
  },

  watch: {
    watchString: {
      immediate: true,
      handler: function handler() {
        this.get();
      }
    }
  },
  computed: {
    watchString: function watchString() {
      return this.touch + ' ' + this.date + ' ' + this.calendarId;
    },
    appointments: function appointments() {
      return this.getObjectPath(this.req, 'result.appointments', []);
    },
    events: function events() {
      return this.appointments.map(function (appointment) {
        var dt = appointment.start_time.split('T')[0];
        var startMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(appointment.start_time);
        var endMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(appointment.end_time);
        appointment.dt = dt;
        appointment.start = startMoment.format('HH:mm');
        appointment.end = endMoment.format('HH:mm');
        appointment.duration = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(endMoment.diff(startMoment)).minutes();
        return appointment;
      });
    }
  },
  methods: {
    get: function get() {
      if (this.calendarId) {
        this.req.resourceId = this.calendarId;
        this.req.params = { date: this.date };
        this.$request('get', this.req);
      }
    }
  }
});

/***/ }),

/***/ 1576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PractitionerDayView_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PractitionerDayView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PractitionerDayView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SharedCalendarDayView_vue__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SharedCalendarDayView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SharedCalendarDayView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_listitems_PractitionerListItem_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_listitems_PractitionerListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_listitems_PractitionerListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_appointment_actions_AppointmentBottomSheet_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_appointment_actions_AppointmentBottomSheet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_appointment_actions_AppointmentBottomSheet_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pickers_SpaceAndLocationPicker__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pickers_SpaceAndLocationPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pickers_SpaceAndLocationPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IntervalSlot__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IntervalSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__IntervalSlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ui_SearchField_vue__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ui_SearchField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_ui_SearchField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_btns_InviteBtn_vue__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_btns_InviteBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_btns_InviteBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_luxon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(6);



















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TeamView',
  components: {
    PractitionerDayView: __WEBPACK_IMPORTED_MODULE_3__PractitionerDayView_vue___default.a,
    SharedCalendarDayView: __WEBPACK_IMPORTED_MODULE_4__SharedCalendarDayView_vue___default.a,
    PractitionerListItem: __WEBPACK_IMPORTED_MODULE_5__components_listitems_PractitionerListItem_vue___default.a,
    AppointmentBottomSheet: __WEBPACK_IMPORTED_MODULE_6__components_appointment_actions_AppointmentBottomSheet_vue___default.a,
    SpaceAndLocationPicker: __WEBPACK_IMPORTED_MODULE_7__components_pickers_SpaceAndLocationPicker___default.a,
    IntervalSlot: __WEBPACK_IMPORTED_MODULE_8__IntervalSlot___default.a,
    SearchField: __WEBPACK_IMPORTED_MODULE_9__components_ui_SearchField_vue___default.a,
    InviteBtn: __WEBPACK_IMPORTED_MODULE_10__components_btns_InviteBtn_vue___default.a
  },
  props: {
    page: { type: String, required: false }
  },
  data: function data() {
    return {
      idToDelete: 135455,
      activeTab: 1,
      date: null,
      monthView: false,
      hideWeekends: false,
      sideMenu: true,
      monthViewType: 'month',
      bottomsheet: false,
      readOnly: false,
      addTeamMember: false,
      ignoredStatuses: ['C'],
      selectedEvent: {},
      selectedPractitioners: {},
      searchString: '',
      filterSpaces: [],
      filterLocations: [],
      selectedAppointments: {},
      visibleSharedCalendarIds: [],
      monthrequest: {
        resource: 'ag.practitioner.appointments',
        status: 0
      },
      dayViewTouch: 0,
      colors: ['green', 'blue', 'yellow', 'teal', 'pink', 'red']
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["b" /* mapGetters */])(['spaces', 'getSharedCalendars']), {
    colleagues: function colleagues() {
      return this.$store.getters.getColleagues;
    },
    flexSize: function flexSize() {
      if (this.visibleSharedCalendarIds && this.selectedPractitionerIds) {
        var visibleCalendars = this.visibleSharedCalendarIds.length + this.selectedPractitionerIds.length;
        var size = Math.floor(12 / visibleCalendars);
        return 'md' + size;
      }
      return '';
    },
    pickerMode: function pickerMode() {
      if (this.monthView) {
        return 'month';
      }
      return 'date';
    },
    requestStatus: function requestStatus() {
      return this.monthrequest.status;
    },
    monthevents: function monthevents() {
      return this.getObjectPath(this.monthrequest, 'result.results', []);
    },
    selectedAppointmentIds: function selectedAppointmentIds() {
      if (this.selectedAppointments) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.selectedAppointments);
      }
      return [];
    },
    selectedPractitionerIds: function selectedPractitionerIds() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.selectedPractitioners);
    },
    startDate: function startDate() {
      return __WEBPACK_IMPORTED_MODULE_13_luxon__["DateTime"].fromISO(this.date).toISODate();
    },
    dateFormatted: function dateFormatted() {
      if (this.date) {
        var dt = __WEBPACK_IMPORTED_MODULE_13_luxon__["DateTime"].fromISO(this.date);
        var f = null;
        if (this.monthView) {
          f = dt.toFormat('MMM yyyy');
        } else {
          f = dt.toLocaleString(__WEBPACK_IMPORTED_MODULE_13_luxon__["DateTime"].DATE_MED_WITH_WEEKDAY);
        }
        return f;
      }
    },
    monthToucher: function monthToucher() {
      if (this.monthView) {
        return this.params.toString() + this.startDate + this.selectedPractitionerIds.toString();
      }
      return '';
    },
    weekdays: function weekdays() {
      if (this.monthView && this.hideWeekends) {
        return [1, 2, 3, 4, 5];
      }
      return [0, 1, 2, 3, 4, 5, 6];
    },
    params: function params() {
      if (this.date) {
        if (this.monthView) {
          var monthStart = __WEBPACK_IMPORTED_MODULE_13_luxon__["DateTime"].fromISO(this.date).startOf('month').toISODate();
          var monthEnd = __WEBPACK_IMPORTED_MODULE_13_luxon__["DateTime"].fromISO(this.date).endOf('month').toISODate();
          var params = new URLSearchParams();
          params.append('page_size', 1000);
          params.append('after_utc', monthStart);
          params.append('before_utc', monthEnd);
          if (this.selectedPractitionerIds) {
            this.selectedPractitionerIds.forEach(function (id) {
              params.append('practitioners', id);
            });
          }
          return params;
        }
      }
      return {};
    },
    visibleSharedCalendars: function visibleSharedCalendars() {
      var _this = this;

      return this.getSharedCalendars.filter(function (cal) {
        return _this.visibleSharedCalendarIds.indexOf(cal.id) > -1;
      });
    }
  }),
  mounted: function mounted() {
    this.date = new Date().toISOString().split('T')[0];
    this.setView(this.page);
    this.getMonth();
  },

  methods: {
    update: function update() {
      if (this.monthView) {
        this.getMonth();
      } else {
        this.dayViewTouch++;
      }
    },
    getMonth: function getMonth() {
      this.monthrequest.params = this.params;
      this.$request('get', this.monthrequest);
    },
    setFilters: function setFilters(_ref) {
      var spaces = _ref.spaces,
          locations = _ref.locations;

      this.filterSpaces = spaces;
      this.filterLocations = locations;
    },
    applyFilters: function applyFilters(evts) {
      var _this2 = this;

      if (this.searchString) {
        evts = evts.filter(function (evt) {
          var index = ('' + evt.title).toLowerCase();
          var search = _this2.searchString.toLowerCase();
          return index.indexOf(search) !== -1;
        });
      }
      if (this.filterSpaces && this.filterSpaces.length > 0) {
        evts = evts.filter(function (evt) {
          return _this2.filterSpaces.indexOf(evt.space) !== -1;
        });
      }
      if (this.filterLocations && this.filterLocations.length > 0) {
        evts = evts.filter(function (evt) {
          return _this2.filterLocations.indexOf(evt.address_id) !== -1;
        });
      }
      return evts;
    },
    getEvents: function getEvents(dt) {
      var evts = this.$store.getters.getCalendarsDay(this.selectedPractitionerIds, dt);
      return this.applyFilters(evts);
    },
    getEventsByHour: function getEventsByHour(dt, hour) {
      var evts = this.getEvents(dt).filter(function (evt) {
        return __WEBPACK_IMPORTED_MODULE_13_luxon__["DateTime"].fromISO(evt.start_time).hour === parseInt(hour);
      });
      return this.applyFilters(evts);
    },
    toggleSpace: function toggleSpace(space, filterSpaces) {
      var index = this.filterSpaces.indexOf(space.id);
      if (index === -1) {
        filterSpaces.push(space.id);
      } else {
        filterSpaces.splice(index, 1);
      }
    },
    isSelected: function isSelected(event) {
      if (event && event.id && this.globalSelectedAppointmentIds.indexOf(event.id) > -1) {
        return true;
      }
      return false;
    },
    setView: function setView(page) {
      if (page === 'month') {
        this.monthView = true;
        this.activeTab = 0;
      } else {
        this.monthView = false;
        this.activeTab = 1;
      }
    },
    setSelectedAppointments: function setSelectedAppointments(appt) {
      this.$store.commit('toggleGloballySelectedAppointment', appt);
    },
    setSelectedAppointment: function setSelectedAppointment(appt, evt) {
      var _this3 = this;

      this.readOnly = appt.practitioner !== this.me.id;
      this.bottomsheet = false;
      this.selectedEvent = appt;
      window.setTimeout(function () {
        _this3.bottomsheet = true;
      }, 100);
    },
    setSelected: function setSelected(practitioner) {
      var practitionerId = practitioner.id;
      if (practitionerId in this.selectedPractitioners) {
        __WEBPACK_IMPORTED_MODULE_11_vue__["default"].delete(this.selectedPractitioners, practitionerId);
      } else {
        __WEBPACK_IMPORTED_MODULE_11_vue__["default"].set(this.selectedPractitioners, practitionerId, practitioner);
      }
    },
    dayClicked: function dayClicked(dt) {
      var vm = this;

      window.setTimeout(function () {
        vm.$store.commit(__WEBPACK_IMPORTED_MODULE_12__store_constants__["j" /* SET_SETTING */], ['startTime', dt.date]);
      }, 500);
      this.openGlobalDialog(true, 'QuickCreate');
    },
    newAppointment: function newAppointment(practitioner) {
      var vm = this;
      window.setTimeout(function () {
        vm.$store.commit(__WEBPACK_IMPORTED_MODULE_12__store_constants__["j" /* SET_SETTING */], ['activePractitioner', practitioner]);
      }, 500);
      this.openGlobalDialog(true, 'QuickCreate');
    },
    zoomIn: function zoomIn(dateItem) {
      this.date = dateItem.date;
      this.activeTab = 1;
      this.monthView = false;
    },
    asTime: function asTime(dt) {
      return __WEBPACK_IMPORTED_MODULE_13_luxon__["DateTime"].fromISO(dt).asLocaleString(__WEBPACK_IMPORTED_MODULE_13_luxon__["DateTime"].TIME_24_SIMPLE);
    }
  },
  watch: {
    requestStatus: function requestStatus() {
      if (this.requestStatus === 200) {
        var events = this.getObjectPath(this.monthrequest, 'result.results', []);
        this.$store.commit('addAppointments', events);
      }
    },
    monthToucher: function monthToucher() {
      if (this.monthView === true) {
        this.getMonth();
      }
    },
    monthView: function monthView() {
      if (this.monthView !== true) {
        if (this.date.length < 10) {
          this.date += '-01';
        }
      }
      this.globalSelectedAppointments = [];
    },
    page: function page() {
      this.setView(this.page);
    },
    newAppointment: function newAppointment(practitioner) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_12__store_constants__["j" /* SET_SETTING */], ['activePractitioner', practitioner]);
      this.openGlobalDialog(true, 'QuickCreate');
    },
    getSharedCalendars: function getSharedCalendars() {
      this.visibleSharedCalendarIds = this.getSharedCalendars.filter(function (cal) {
        if (cal.default_show) {
          return cal;
        }
      }).map(function (cal) {
        return cal.id;
      });
    },

    colleagues: {
      immediate: true,
      handler: function handler() {
        this.selectedPractitioners = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.colleagues));
      }
    }
  }
});

/***/ }),

/***/ 1604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchField',
  props: {
    value: { type: String, required: true },
    attrs: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      searchString: null
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        this.searchString = this.value;
      }
    },
    searchString: function searchString() {
      this.$emit('input', this.searchString);
    }
  }
});

/***/ }),

/***/ 1606:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1555)(true);
// imports


// module
exports.push([module.i, ".v-calendar-monthly .v-chip,.v-chip .v-chip__content{border-radius:28px 5px 5px 28px}", "", {"version":3,"sources":["/opt/build/repo/src/components/calendar/TeamView.vue"],"names":[],"mappings":"AACA,qDACE,+BAAiC,CAClC","file":"TeamView.vue","sourcesContent":["\n.v-calendar-monthly .v-chip, .v-chip .v-chip__content {\n  border-radius: 28px 5px 5px 28px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1613:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1606);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1556)("eecb561e", content, true, {});

/***/ }),

/***/ 1621:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1574),
  /* template */
  __webpack_require__(1667),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1622:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1575),
  /* template */
  __webpack_require__(1668),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1642:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1604),
  /* template */
  __webpack_require__(1665),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1649:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.sideMenu) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md3": "",
      "lg3": "",
      "xl2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "dark": "",
      "height": "100%"
    }
  }, [_c('v-tabs', {
    attrs: {
      "grow": "",
      "dark": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', {
    on: {
      "click": function($event) {
        _vm.monthView = true
      }
    }
  }, [_vm._v("Month view")]), _vm._v(" "), _c('v-tab', {
    on: {
      "click": function($event) {
        _vm.monthView = false
      }
    }
  }, [_vm._v("Side by side")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.date) ? _c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "full-width": "",
      "type": _vm.pickerMode
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.monthView) ? _c('v-switch', {
    staticClass: "mx-3 my-0",
    attrs: {
      "label": "Hide weekends",
      "dense": ""
    },
    model: {
      value: (_vm.hideWeekends),
      callback: function($$v) {
        _vm.hideWeekends = $$v
      },
      expression: "hideWeekends"
    }
  }) : _vm._e(), _vm._v(" "), [_c('v-subheader', {
    staticClass: "overline my-0"
  }, [_vm._v("Calendars")]), _vm._v(" "), _c('v-list', [_vm._l((_vm.colleagues), function(practitioner, practitionerId) {
    return [_c('practitioner-list-item', {
      key: practitionerId,
      attrs: {
        "with-avatar": true,
        "item": practitioner
      },
      on: {
        "selected": function($event) {
          return _vm.setSelected(practitioner)
        }
      }
    }, [_c('template', {
      slot: "action"
    }, [_c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "small": "",
        "outline": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.newAppointment(practitioner)
        }
      }
    }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [(practitioner.id in _vm.selectedPractitioners) ? _c('v-icon', {
      attrs: {
        "color": practitioner.color
      }
    }, [_vm._v("check_box")]) : _c('v-icon', {
      attrs: {
        "color": practitioner.color
      }
    }, [_vm._v("check_box_outline_blank")])], 1)], 1)], 2), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (practitioner.id))
    })]
  })], 2)], _vm._v(" "), (_vm.getSharedCalendars && _vm.getSharedCalendars.length > 0) ? [_c('v-subheader', {
    staticClass: "overline my-0"
  }, [_vm._v("Shared\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.getLookupsRequest.loading
    },
    on: {
      "click": _vm.getLookups
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.getSharedCalendars), function(cal) {
    return _c('v-list-tile', {
      key: cal.id
    }, [_c('v-list-tile-content', [_c('v-checkbox', {
      attrs: {
        "hide-details": "",
        "label": cal.title,
        "value": cal.id
      },
      model: {
        value: (_vm.visibleSharedCalendarIds),
        callback: function($$v) {
          _vm.visibleSharedCalendarIds = $$v
        },
        expression: "visibleSharedCalendarIds"
      }
    })], 1)], 1)
  }), 1)] : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('invite-btn', {
    attrs: {
      "attrs": {
        block: true
      }
    }
  })], 1)], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": _vm.sideMenu,
      "md9": _vm.sideMenu,
      "lg9": _vm.sideMenu,
      "xl10": _vm.sideMenu
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon', [_c('v-btn', {
    attrs: {
      "icon": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.sideMenu = !_vm.sideMenu
      }
    }
  }, [_c('v-icon', [_vm._v("menu")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.monthrequest.loading,
      "icon": "",
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.update
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.dateFormatted))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('space-and-location-picker', {
    on: {
      "input": _vm.setFilters
    }
  }), _vm._v(" "), (_vm.monthView) ? _c('search-field', {
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.monthView) ? [_c('v-flex', [_c('v-card', {
    attrs: {
      "tile": "",
      "height": "100%"
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.monthrequest,
      "message200": false
    }
  }), _vm._v(" "), _c('v-calendar', {
    attrs: {
      "value": _vm.startDate,
      "events": _vm.$store.getters.getEventRange,
      "type": _vm.monthViewType,
      "weekdays": _vm.weekdays
    },
    on: {
      "click:date": _vm.zoomIn,
      "click:day": _vm.dayClicked
    },
    scopedSlots: _vm._u([{
      key: "day",
      fn: function(ref) {
        var date = ref.date;

        return [_vm._l((_vm.getEvents(date)), function(event) {
          return [(event.id && _vm.ignoredStatuses.indexOf(event.status)) ? _c('v-chip', {
            key: event.id,
            staticClass: "v-chip--x-small ma-0",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "color": _vm.colleagues[event.practitioner].color,
              "outline": "",
              "block": ""
            },
            on: {
              "click": [function($event) {
                if (!$event.metaKey) { return null; }
                $event.stopPropagation();
                return _vm.setSelectedAppointments(event)
              }, function($event) {
                if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
                $event.stopPropagation();
                return _vm.setSelectedAppointment(event)
              }]
            }
          }, [_c('v-avatar', {
            staticClass: "mr-1",
            staticStyle: {
              "max-width": "16px!important",
              "max-height": "16px!important",
              "min-width": "16px!important",
              "min-height": "16px!important"
            }
          }, [(_vm.isSelected(event)) ? _c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("check")]) : _c('img', {
            attrs: {
              "src": _vm.colleagues[event.practitioner].profile_picture
            }
          })], 1), _vm._v("\n                  " + _vm._s(event.title) + "\n                  "), _c('small', {
            staticStyle: {
              "position": "absolute",
              "right": "5px"
            }
          }, [_vm._v(_vm._s(event.start))])], 1) : _vm._e()]
        })]
      }
    }, {
      key: "interval",
      fn: function(ref) {
        var date = ref.date;
        var hour = ref.hour;

        return [_vm._l((_vm.getEventsByHour(date, hour)), function(event) {
          return [_c('interval-slot', {
            key: ((event.id) + "-" + date + "-" + hour),
            attrs: {
              "flat": "",
              "small": "",
              "color": _vm.colleagues[event.practitioner].color,
              "events": _vm.getEvents(date),
              "event": event
            }
          })]
        })]
      }
    }], null, false, 4110408284)
  })], 1)], 1)] : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.selectedPractitioners), function(practitioner) {
    return _c('v-flex', {
      key: practitioner.id,
      class: _vm.flexSize
    }, [(_vm.date) ? _c('practitioner-day-view', {
      attrs: {
        "with-title": "",
        "with-add": "",
        "with-fetch": "",
        "practitioner": practitioner,
        "filter-spaces": _vm.filterSpaces,
        "filter-locations": _vm.filterLocations,
        "touch": _vm.dayViewTouch,
        "date": _vm.date
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.visibleSharedCalendars && _vm.visibleSharedCalendars.length > 0) ? _vm._l((_vm.visibleSharedCalendars), function(cal) {
    return _c('v-flex', {
      key: cal.id,
      class: _vm.flexSize
    }, [(_vm.date) ? _c('shared-calendar-day-view', {
      attrs: {
        "with-title": "",
        "with-add": "",
        "calendar-id": cal.id,
        "title": cal.title,
        "date": _vm.date
      }
    }) : _vm._e()], 1)
  }) : _vm._e()], 2)], 2), _vm._v(" "), _c('appointment-bottom-sheet', {
    attrs: {
      "appointment": _vm.selectedEvent,
      "readOnly": _vm.readOnly
    },
    model: {
      value: (_vm.bottomsheet),
      callback: function($$v) {
        _vm.bottomsheet = $$v
      },
      expression: "bottomsheet"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "420"
    },
    model: {
      value: (_vm.addTeamMember),
      callback: function($$v) {
        _vm.addTeamMember = $$v
      },
      expression: "addTeamMember"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n        Coming soon\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        This functionality is not yet available. To add a team member, please\n        "), _c('a', {
    attrs: {
      "href": "mailto:support@appointmentguru.co"
    }
  }, [_vm._v("contact support")]), _vm._v(".\n        Please note that there is an additional cost of R150/month for each additional team member\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.addTeamMember = false
      }
    }
  }, [_vm._v("Got it")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1665:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', _vm._b({
    attrs: {
      "clearable": "",
      "placeholder": "Search",
      "prepend-icon": "search"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.stopPropagation();
        _vm.searchString = ""
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }, 'v-text-field', _vm.attrs, false))
},staticRenderFns: []}

/***/ }),

/***/ 1667:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "px-1",
    class: [_vm.color, 'lighten-4'],
    style: (_vm.dayEventStyle(_vm.event, _vm.events)),
    attrs: {
      "flat": "",
      "small": ""
    }
  }, [_c('small', [_c('strong', [_vm._v(_vm._s(_vm.event.title || _vm.event.full_name))]), _c('br'), _vm._v("\n      " + _vm._s(_vm.event.start) + " - " + _vm._s(_vm.event.end) + "\n    ")])])
},staticRenderFns: []}

/***/ }),

/***/ 1668:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [(_vm.withTitle) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dark": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          Custom shared calendar\n          "), _c('v-chip', {
    staticClass: "v-chip--x-small"
  }, [_vm._v("Read only")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "loading": _vm.req.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.date && _vm.calendarId) ? _c('day-view', {
    staticClass: "ml-0",
    attrs: {
      "flat": "",
      "readOnly": true,
      "date": _vm.date,
      "with-fetch": false,
      "start-hour": _vm.settings.startHour,
      "end-hour": _vm.settings.endHour,
      "events": _vm.events
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.5171c02d9d442cbd2437.js